module.exports = __webpack_public_path__ + "static/media/Miracle Girls - English v1.1.085b74d0.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/Miracle Girls - English v1.1.zip
// module id = 52
// module chunks = 0